import { Helmet } from "react-helmet-async";
import { useLocation, useParams } from "react-router-dom";
import { siteConfig } from "../config/site";
import { languages, normalizeLang } from "../lib/i18n";

const siteName = siteConfig.name;
const siteUrl = siteConfig.url;
const defaultImage = siteConfig.ogImage;

export default function Seo({ title, description, image = defaultImage }: { title: string; description: string; image?: string }) {
  const location = useLocation();
  const { lang } = useParams();
  const currentLang = normalizeLang(lang);
  const pathWithoutLang = location.pathname.replace(/^\/(en|zh|es|ru|tg)/, "") || "";
  const canonical = `${siteUrl}/${currentLang}${pathWithoutLang}`;
  const fullTitle = title === siteName ? siteName : `${title} | ${siteName}`;

  return (
    <Helmet>
      <html lang={currentLang} />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={canonical} />
      <meta name="twitter:card" content="summary_large_image" />
      <link rel="canonical" href={canonical} />
      {languages.map((item) => (
        <link key={item.code} rel="alternate" hrefLang={item.code} href={`${siteUrl}/${item.code}${pathWithoutLang}`} />
      ))}
      <link rel="alternate" hrefLang="x-default" href={`${siteUrl}/en${pathWithoutLang}`} />
    </Helmet>
  );
}
